export const ICONS: string[] = ['ak-globe-web', 'ak-error', 'ak-info-filled', 'ak-warning', 'ak-success'];
